Object.defineProperty(exports, "__esModule", {
  value: true
}); // TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata

exports.SDK_NAME = 'sentry.javascript.browser';